export const SET_USER = 'SET_USER';
export const SET_HAS_FETCHED_COMMUNICATION_DATA = 'SET_HAS_FETCHED_COMMUNICATION_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_WITHDRAWAL_ABILITY = 'SET_WITHDRAWAL_ABILITY';
export const SET_IS_AUTHENTICATING = 'SET_IS_AUTHENTICATING';
export const SET_IS_CHECKED_AUTHENTICATION = 'SET_IS_CHECKED_AUTHENTICATION';
export const SET_IS_ACCEPTED_RESPONSIBLE_GAMBLING = 'SET_IS_ACCEPTED_RESPONSIBLE_GAMBLING';
export const SET_SESSION_START_TIME = 'SET_SESSION_START_TIME';
// TODO: Remove after SB Club hackathon is over
export const SET_OMNI_WALLET_STATUS = 'SET_OMNI_WALLET_STATUS';
export const SET_IS_RETURNING_USER_DEVICE = 'SET_IS_RETURNING_USER_DEVICE';
export const SET_DEPOSIT_ELIGIBILITY = 'SET_DEPOSIT_ELIGIBILITY';
export const SET_FAILED_LOGIN_ATTEMPTS = 'SET_FAILED_LOGIN_ATTEMPTS';
export const SET_HAS_VISITED_ACCOUNT_SECURITY = 'SET_HAS_VISITED_ACCOUNT_SECURITY';
